import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import Footer from "./components/Footer";
import Home from "./views/Home";
import '../src/style/body-style.css';
import '../src/style/style.css';
import '../src/style/ds-theme.css';
import SearchDetails from './views/SearchDetails';
import { LanguageProvider } from './components/LanguageContext';
import { createHashRouter, Outlet, RouterProvider, useLocation } from 'react-router-dom';
import RequestSubmitted from './views/RequestSubmitted';

document.body.setAttribute('lang', 'en');
window.history.scrollRestoration = 'manual';

function AppShell() {
  const location = useLocation();

  React.useLayoutEffect(() => {
    const scrollingElement = document.scrollingElement || document.documentElement || document.body;

    if (scrollingElement) {
      scrollingElement.scrollTop = 0;
    }

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const root = document.getElementById('root');
    if (root) {
      root.scrollTop = 0;
    }
  }, [location.pathname, location.hash, location.search]);

  return <Outlet />;
}

const router = createHashRouter([
  {
    element: <AppShell />,
    children: [
      {
        path: "/",
        element: (
          <div className='app-container'>
            <Home />
          </div>
        ),
      },
      // {
      //   path: "/fr",
      //   element:  <div className='app-container'>     
      //               <FrenchHome/>
      //               <FrenchFooter/>
      //             </div>,
      // },
      {
        path: "/searchDetails",
        element: (
          <div className='app-container'>
            <SearchDetails />
          </div>
        ),
      },
      {
        path: "/RequestSubmitted",
        element: (
          <div className='app-container'>
            <RequestSubmitted />
          </div>
        ),
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <LanguageProvider>
    <RouterProvider router={router} />
  </LanguageProvider>
);

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <RouterProvider router={router} />
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
